import { RequisitionFormSearchCriteria } from "domain/entity/RequisitionForm/RequisitionFormSearchCriteria";
import { RequisitionFormConstant } from "presentation/constant/RequisitionForm/RequisitionFormConstant";
import { useRequisitionFormVM } from "presentation/hook/RequisitionForm/useRequisitionFormVM";
import { useRequisitionFormMaintenanceTracked } from "presentation/store/RequisitionForm/RequisitionFormMaintenanceProvider";
import { useCallback, useState } from "react";
import { HPHButton, IconButton, Loader } from "veronica-ui-component/dist/component/core";
import { SidebarActionBar, SidebarActionCross, SidebarTitle, Sidebarheader } from "veronica-ui-component/dist/component/core/styled/uiFramework.styled";
import RequisitionFormSearchForm from "./RequisitionFormSearchForm";

const RequisitionFormSearchPanel = () => {
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const REQ_FORM_CONSTANT = RequisitionFormConstant.Header;
    const [requisitionFormState] = useRequisitionFormMaintenanceTracked();
    const requisitionFormVM = useRequisitionFormVM();
    const { reqNatureKeyMap } = requisitionFormState;
    const resetButtonClicked = useCallback(() => {
        requisitionFormVM.onSearchCriteriaResetClick();
    }, [requisitionFormVM]);

    const searchButtonClicked = useCallback((criteria: RequisitionFormSearchCriteria) => {
        setIsLoading(true);
        requisitionFormVM.getRequisitionForms(reqNatureKeyMap, criteria).then((data) => {
            setIsLoading(false);
        }).catch(error => {
            setIsLoading(false);
        })

    }, [reqNatureKeyMap, requisitionFormVM])

    return (
        <div className='side-form-content-left-wrapper' style={{ padding: "20px 20px 20px 0px", display: 'flex', flexDirection: 'column', height: 'calc(100vh - 62px)' }}>
            <div className={'flex-row'}>
                <div className={'flex-row-item flex-row-item-full-width'}>
                    <Sidebarheader>
                        <SidebarTitle>{REQ_FORM_CONSTANT.SEARCH_CRITERIA}</SidebarTitle>
                        <SidebarActionCross>
                            <IconButton
                                fileName="Icon-cross" size="medium" toolTipText='Close' toolTipArrow={false} onClick={requisitionFormVM.onSearchClick} />
                        </SidebarActionCross>
                    </Sidebarheader>
                </div>
            </div>

            {isLoading && <Loader Indicator="Spinner" size="Medium" />}

            <div className={'add-edit-form'} style={{ minHeight: '0', flex: '1', overflowY: 'auto' }}>
                <div className="flex-row-auto">
                    <div className={'flex-row-item'}>

                        {/* Stack Form Start */}
                        <RequisitionFormSearchForm />
                    </div>
                </div>
            </div>
            <SidebarActionBar>
                <HPHButton label={'Reset'} size={'Small'} theme={'Secondary'} onClick={resetButtonClicked} />
                <HPHButton label={'Search'} size={'Small'} theme={'Primary'} onClick={() => searchButtonClicked(requisitionFormState.searchCriteria)} />
            </SidebarActionBar>
            {requisitionFormState.forceRefresh && <></>}
        </div>
    );
}

export default RequisitionFormSearchPanel;